import React, {
  createContext,
  useContext,
  SetStateAction,
  Dispatch,
  FC,
  ReactNode,
  useState,
} from 'react'
import { ModalProps } from 'react-bootstrap/Modal'

export type AlertDialogState = {
  size?: ModalProps['size']
  title: string
  body: string
}

export const initialConfirmationState: AlertDialogState = {
  size: 'sm',
  title: '',
  body: '',
}

export type AlertDialogContextType = {
  alertDialogState: AlertDialogState
  setAlertDialogState: Dispatch<SetStateAction<AlertDialogState>>
}

export const AlertDialogContext = createContext<AlertDialogContextType>({
  alertDialogState: initialConfirmationState,
  setAlertDialogState: () => null,
})

export const useAlertDialogContext = (): AlertDialogContextType =>
  useContext(AlertDialogContext)

export const AlertDialogProvider: FC<{
  children: ReactNode
}> = ({ children }) => {
  const [alertDialogState, setAlertDialogState] = useState<AlertDialogState>(
    initialConfirmationState,
  )

  return (
    <AlertDialogContext.Provider
      value={{ alertDialogState, setAlertDialogState }}
    >
      {children}
    </AlertDialogContext.Provider>
  )
}
